var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trigger-item"},[_c('p',[_vm._v(" "+_vm._s(_vm.item.name)+" "),_c('button',{staticClass:"del",on:{"click":function($event){return _vm.$emit('del-item', _vm.item.id)}}},[_vm._v("x")])])])}
var staticRenderFns = []

export { render, staticRenderFns }